module.exports = __webpack_public_path__ + "img/icon_hunyanyuqingdian_home.039d35e3.png";